// extracted by mini-css-extract-plugin
module.exports = {"pair":"PairOfInfoItems_pair__3l2RQ","centered":"PairOfInfoItems_centered__3sf6z","info":"PairOfInfoItems_info__3Q47n"};